// --- generateUUID
// generate a standard longform uuid (36 digits)
// better for greater security and
// when you have a very large amount of elements that need UIDs

import generate from "./generate.js"

export default function generateUUID ({ seed } = {}) {
    return generate({
        digits: 36,
        seed
    })
}